<template>
  <div class="sandbox">
    <section>
      <bermuda-columns>
        <template slot="A">
          <p class="title">Notifications</p>
        </template>
        <template slot="B">
          <b-notification type="is-success"
            >Something good happened
          </b-notification>
          <b-notification type="is-danger"
            >Something bad happened
          </b-notification>
          <b-notification type="is-info"
            >This is something informative
          </b-notification>
        </template>
      </bermuda-columns>
    </section>

    <section class="has-border-top">
      <bermuda-columns>
        <template slot="A">
          <p class="title">UMessage</p>
        </template>
        <template slot="B">
          <u-message
            class="has-margin-bottom-75"
            icon="info-circle"
            title="Neutral message (default)"
            >This is an example of a 'neutral' message.
          </u-message>

          <u-message
            class="has-margin-bottom-75"
            icon="info-circle"
            type="is-info"
            title="Informative message"
            >This is an example of an 'informative' message + one action.
            <u-link slot="action" icon-right="arrow-right">
              <strong>Here's a link</strong>
            </u-link>
          </u-message>

          <u-message
            class="has-margin-bottom-75"
            icon="check-circle"
            type="is-success"
            title="Success message"
            >This is an example of a 'success' message + two actions.
            <u-link slot="action">
              <strong>Here's a link</strong>
            </u-link>
            <u-link slot="action">
              <strong>And another</strong>
            </u-link>
          </u-message>

          <u-message
            class="has-margin-bottom-75"
            icon="ban"
            type="is-caution"
            title="Cautious message"
            :is-processing="true"
            >This is an example of a 'cautious' message + processing state.
          </u-message>

          <u-message
            class="has-margin-bottom-75"
            icon="exclamation-circle"
            type="is-warning"
            title="Warning message"
            :is-processing="true"
            >This is an example of a 'warning' message + one disabled action +
            processing state.
            <u-link slot="action" :disabled="true" icon-right="arrow-right">
              <strong>Here's a link</strong>
            </u-link>
          </u-message>

          <u-message
            class="has-margin-bottom-75"
            icon="exclamation-triangle"
            type="is-danger"
            title="Danger message"
            :is-processing="true"
            >This is an example of a 'danger' message + two disabled actions +
            processing state.
            <u-link slot="action" :disabled="true">
              <strong>Here's a link</strong>
            </u-link>
            <u-link slot="action" :disabled="true">
              <strong>And another</strong>
            </u-link>
          </u-message>
        </template>
      </bermuda-columns>
    </section>

    <section class="has-border-top">
      <bermuda-columns>
        <template slot="A">
          <p class="title">Loader</p>
        </template>
        <template slot="B">
          <loading />
        </template>
      </bermuda-columns>
    </section>

    <section class="has-background-light has-border-top">
      <bermuda-columns>
        <template slot="A">
          <p class="title">Stats</p>
        </template>
        <template slot="B">
          <columns>
            <column class="is-4">
              <stat label="Customer since" value="Jun 1st, 2009" />
            </column>
            <column class="is-4">
              <stat label="I link somewhere" to="/some/path" value="£1590.27" />
            </column>
            <column class="is-4">
              <stat label="Monthly spend" value="£230.27" />
            </column>
          </columns>
        </template>
      </bermuda-columns>
    </section>

    <section class="has-background-light has-border-top">
      <bermuda-columns>
        <template slot="A">
          <p class="title">Collapse</p>
          <p class="subtitle is-size-6">{{ $t("_sentence.lipsum") }}</p>
        </template>
        <template slot="B">
          <collapse title="Collapse">Some content</collapse>
        </template>
      </bermuda-columns>
    </section>

    <section class="has-border-top">
      <bermuda-columns>
        <template slot="A">
          <p class="title">Vessel</p>
          <p class="subtitle is-size-6">{{ $t("_sentence.lipsum") }}</p>
        </template>
        <template slot="B">
          <vessel to="/some/path" type="router-link">
            <strong slot="middleLeft">Simple vessel</strong>
            <b-icon icon="chevron-right" size="is-small" slot="action" />
          </vessel>

          <vessel type="div">
            <img
              slot="media"
              src="/assets/images/interface/payment-providers/visa.svg"
            />
            <strong slot="topLeft">Visa</strong>
            <p class="is-size-7 has-text-grey" slot="bottomLeft">
              Card ending 2548
            </p>
            <b-tag slot="middleRight" type="is-info">Default</b-tag>
            <b-dropdown
              :mobile-modal="false"
              :ref="`card_id_234`"
              position="is-bottom-left"
              slot="action"
            >
              <button
                @click.stop.prevent="$refs[`card_id_234`].toggle()"
                class="button"
                slot="trigger"
              >
                <b-icon icon="cog" size="is-small" />
              </button>
              <b-dropdown-item aria-role="listitem">Edit name</b-dropdown-item>
              <b-dropdown-item aria-role="listitem">Delete</b-dropdown-item>
            </b-dropdown>
          </vessel>

          <vessel to="/some/path" type="router-link">
            <strong slot="middleLeft">Simple vessel</strong>
            <b-dropdown aria-role="list" ref="dropdown" slot="action">
              <button
                @click.stop.prevent="$refs.dropdown.toggle()"
                class="button"
                slot="trigger"
              >
                Click me
              </button>
              <b-dropdown-item aria-role="listitem">Action</b-dropdown-item>
              <b-dropdown-item aria-role="listitem"
                >Another action
              </b-dropdown-item>
              <b-dropdown-item aria-role="listitem"
                >Something else
              </b-dropdown-item>
            </b-dropdown>
          </vessel>

          <!-- <vessel-fleet v-for="index in [0,1,2,3]" :key="index">
            <vessel type="router-link" to="/some/path">
              <strong slot="middleLeft">Simple vessel {{ index }}</strong>
              <b-dropdown :ref="`example-dropdown`" aria-role="list" slot="action">
                <button
                  class="button"
                  slot="trigger"
                  @click.stop.prevent="$refs[`example-dropdown`][index].toggle()"
                >Click me</button>
                <b-dropdown-item aria-role="listitem">Action</b-dropdown-item>
                <b-dropdown-item aria-role="listitem">Another action</b-dropdown-item>
                <b-dropdown-item aria-role="listitem">Something else</b-dropdown-item>
              </b-dropdown>
            </vessel>
          </vessel-fleet>-->

          <vessel to="/" type="router-link">
            <img
              slot="media"
              src="https://i0.wp.com/www.winhelponline.com/blog/wp-content/uploads/2017/12/user.png?fit=256%2C256&quality=100&ssl=1"
            />
            <strong slot="topLeft">Jon Springham</strong>
            <template slot="bottomLeft">jon@upmind.com </template>
            <span class="has-text-grey is-size-7" slot="middleRight"
              >Created 5 days ago</span
            >
            <b-icon icon="chevron-right" size="is-small" slot="action" />
          </vessel>

          <vessel type="div">
            <strong slot="topLeft">INV-000000000123</strong>
            <template slot="bottomLeft">
              Issued to
              <router-link @click.native.stop to="/sandbox"
                >Chris Garner
              </router-link>
              on 19/05/2019
            </template>
            <strong slot="topRight">£245.00 GBP</strong>
            <span class="has-text-danger" slot="bottomRight"
              >Due 22/07/2019</span
            >
            <button
              @click.stop
              class="button is-rounded is-outlined is-danger"
              slot="action"
            >
              Pay
            </button>
          </vessel>

          <vessel type="div">
            <template slot="topLeft">
              <strong>Vessel with body</strong>
            </template>
            <template slot="bottomLeft">This vessel has body content </template>
            <template slot="body">Stop checking out my body... </template>
            <template slot="footer">
              <a>I'm a link</a>
            </template>
          </vessel>

          <vessel-fleet>
            <vessel>
              <template slot="topLeft">
                <strong>Vessel 1</strong>
              </template>
              <template slot="bottomLeft">Some useful sub text </template>
              <template slot="body">Some content... </template>
              <b-icon
                :icon="actionProps.isOpen ? 'chevron-up' : 'chevron-down'"
                size="is-small"
                slot="action"
                slot-scope="actionProps"
              />
            </vessel>
          </vessel-fleet>
        </template>
      </bermuda-columns>
    </section>

    <section class="has-border-top">
      <bermuda-columns>
        <template slot="A">
          <p class="title">Vessels</p>
          <p class="subtitle is-size-6">{{ $t("_sentence.lipsum") }}</p>
        </template>
        <template slot="B">
          <vessel-fleet>
            <vessel>
              <template slot="topLeft">
                <strong>Vessel 1</strong>
              </template>
              <template slot="bottomLeft">Some useful sub text </template>
              <template slot="body">Some content... </template>
              <b-icon
                :icon="actionProps.isOpen ? 'chevron-up' : 'chevron-down'"
                size="is-small"
                slot="action"
                slot-scope="actionProps"
              />
            </vessel>
            <vessel>
              <template slot="topLeft">
                <strong>Vessel 2</strong>
              </template>
              <template slot="bottomLeft">Some useful sub text </template>
              <template slot="body">Some content... </template>
              <b-icon
                :icon="actionProps.isOpen ? 'chevron-up' : 'chevron-down'"
                size="is-small"
                slot="action"
                slot-scope="actionProps"
              />
              <template slot="footer">
                <a>I'm a link</a>
              </template>
            </vessel>
            <vessel>
              <template slot="topLeft">
                <strong>Vessel 3</strong>
              </template>
              <template slot="bottomLeft">Some useful sub text </template>
              <template slot="body">Some content... </template>
              <b-icon
                :icon="actionProps.isOpen ? 'chevron-up' : 'chevron-down'"
                size="is-small"
                slot="action"
                slot-scope="actionProps"
              />
            </vessel>
          </vessel-fleet>
        </template>
      </bermuda-columns>
    </section>

    <section class="has-border-top">
      <bermuda-columns>
        <template slot="A">
          <p class="title">Selector</p>
          <!-- <p class="subtitle is-size-6">{{ $t("_sentence.lipsum") }}</p> -->
        </template>
        <template slot="B">
          <columns>
            <column class="is-12">
              <selector
                :items="availableBillingTerms"
                :required="true"
                v-model="selectedBillingTerm"
              />
            </column>
            <column class="is-12">
              <selector
                :items="availableOptions"
                class="has-background-white"
                v-model="selectedOption"
              >
                <template v-slot:left-label="slotProps">{{
                  slotProps.item.leftLabel
                }}</template>
                <template v-slot:right-label="slotProps">{{
                  slotProps.item.rightLabel
                }}</template>
                <template v-slot:desc="slotProps">{{
                  slotProps.item.desc
                }}</template>
              </selector>
            </column>
            <column class="is-12">
              <selector
                :items="availableOptions"
                :multiselect="true"
                v-model="selectedOptions"
              />
            </column>
          </columns>
        </template>
      </bermuda-columns>
    </section>

    <section class="has-border-top">
      <bermuda-columns>
        <template slot="A">
          <p class="title">Radio box</p>
        </template>
        <template slot="B">
          <columns class="field-columns">
            <column>
              <radio-box
                :desc="$t('_sentence.one_off_payment_desc')"
                :deselect="true"
                :title="$t('_.credit_or_debit_card')"
                icon="credit-card"
                nativeValue="credit_card"
                v-model="radioBox"
              />
            </column>
            <column>
              <radio-box
                :desc="$t('_sentence.one_off_payment_desc')"
                :deselect="true"
                :title="$t('_.direct_debit')"
                nativeValue="direct_debit"
                v-model="radioBox"
              />
            </column>
            <column>
              <radio-box
                :desc="$t('_sentence.one_off_payment_desc')"
                :deselect="true"
                :disabled="true"
                :title="$t('_.bank_transfer')"
                nativeValue="bank_transfer"
                v-model="radioBox"
              />
            </column>
            <column class="is-12">
              <radio-box
                :deselect="true"
                :title="$t('_.manual_payment')"
                nativeValue="manual_payment"
                v-model="radioBox"
              />
            </column>
          </columns>
        </template>
      </bermuda-columns>
    </section>

    <section class="has-border-top">
      <bermuda-columns>
        <template slot="A">
          <p class="title">Contextualise</p>
          <!-- <p class="subtitle is-size-6">{{ $t("_sentence.lipsum") }}</p> -->
        </template>
        <template slot="B">
          <contextualise label="Currency">
            <template slot="desc"
              >This is the currency your products are sold in. After your first
              sale, currency is locked and can’t be changed.
            </template>
            <b-field>
              <b-input class="is-stretched" type="text" />
            </b-field>
          </contextualise>

          <contextualise label="Store address">
            <template slot="desc"
              >This is your main business address which will appear on your
              generated invoices.
            </template>
            <b-field label="Legal business name">
              <b-input
                class="is-stretched"
                placeholder="Legal business name"
                type="text"
              />
            </b-field>
            <b-field label="Business address">
              <b-input
                class="is-stretched"
                placeholder="Address line 1"
                type="text"
              />
            </b-field>
            <b-field>
              <b-input
                class="is-stretched"
                placeholder="Address line 2"
                type="text"
              />
            </b-field>
            <b-field>
              <b-input class="is-stretched" placeholder="City" type="text" />
            </b-field>
          </contextualise>
        </template>
      </bermuda-columns>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radioBox: "bank_transfer",
      availableBillingTerms: [
        {
          leftLabel: "Pay monthly",
          rightLabel: "£20"
        },
        {
          leftLabel: "Pay every 6 months",
          rightLabel: "£150"
        },
        {
          leftLabel: "Pay every year",
          rightLabel: "£300"
        }
      ],
      selectedBillingTerm: null,
      availableOptions: [
        {
          leftLabel: "100% cotton robe",
          rightLabel: "+£19.99",
          desc:
            "Our range are made from the finest quality materials to ensure they have not only excellent absorbency properties but are also super-soft on your skin."
        },
        {
          leftLabel: "Slippers",
          rightLabel: "+9.99",
          desc: "Our luxury slippers are only available online."
        },
        {
          rightLabel: "+£1.99",
          leftLabel: "Cleansing kit"
        }
      ],
      selectedOption: 2,
      selectedOptions: [1]
    };
  },
  methods: {
    onClick(vm) {
      // tslint:disable-next-line:no-console
      console.log("dropdown clicked", vm);
    }
  }
};
</script>

<style lang="scss" scoped>
.sandbox {
  height: 100vh;
  @include is-scrollable;

  section {
    padding: calc(0.5vw + 3vh);

    & > .columns {
      width: 100%;
      max-width: 1080px;
      margin: 0 auto;
    }
  }
}
</style>
